import { render, staticRenderFns } from "./PatchNotes.vue?vue&type=template&id=780527fe&scoped=true&"
import script from "./PatchNotes.vue?vue&type=script&lang=js&"
export * from "./PatchNotes.vue?vue&type=script&lang=js&"
import style0 from "./PatchNotes.vue?vue&type=style&index=0&id=780527fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../explorakit/vue-explorakit/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780527fe",
  null
  
)

export default component.exports